import { inViewMargin } from '@helpers/animate';
import { useInView } from '@hooks/useInView';
import SvgNext from '@img/icons/carousel-next.svg';
import SvgPrev from '@img/icons/carousel-prev.svg';
import { MotionConfig } from 'framer-motion';
import * as React from 'react';
import Button from '../Button/Button';
import CarouselProvider from '../Carousel/CarouselProvider/CarouselProvider';
import Connected from '../Carousel/Connected/Connected';
import LiveRegion from '../Carousel/LiveRegion/LiveRegion';
import MotionTrack from '../Carousel/MotionTrack/MotionTrack';
import LinkButton from '../LinkButton/LinkButton';
import S from './CardCarousel.styles';
function CardCarousel(props) {
    const [refContainer, inView] = useInView({ rootMargin: inViewMargin });
    return (React.createElement(MotionConfig, { transition: { duration: 0.45, ease: 'easeOut' } },
        React.createElement(CarouselProvider, { count: props.items.length },
            React.createElement(S.Container, { ref: refContainer, id: props.id, className: props.className, "data-inview": inView, "data-theme": props.themeOption ?? 'dark' },
                React.createElement(S.Inner, null,
                    React.createElement(S.ContentWrapper, null,
                        React.createElement(S.Title, { id: props.title.replaceAll(/[\W_]+/g, '-').toLowerCase() }, props.title),
                        props.content && React.createElement(S.Content, null, props.content)),
                    React.createElement(Connected, null, ({ activeIndex, goToNext, goToPrev, maxIndex }) => (React.createElement(S.ControlsWrapper, null,
                        React.createElement(Button, { buttonType: props.themeOption === 'light' ? 'default' : 'inverted', disabled: activeIndex === 0, fillDirection: "left", icon: React.createElement(SvgPrev, null), iconOnly: true, onClick: (event) => {
                                event.preventDefault();
                                goToPrev();
                            } }, "Previous"),
                        React.createElement(Button, { buttonType: props.themeOption === 'light' ? 'default' : 'inverted', disabled: activeIndex === maxIndex, fillDirection: "right", icon: React.createElement(SvgNext, null), iconOnly: true, onClick: (event) => {
                                event.preventDefault();
                                goToNext();
                            } }, "Next")))),
                    props.cta && (React.createElement(S.CtaWrapper, null,
                        React.createElement(LinkButton, { buttonType: props.themeOption === 'light' ? 'default' : 'inverted', href: props.cta.url, target: props.cta.target }, props.cta.text))),
                    React.createElement(S.CarouselWrapper, null,
                        React.createElement(LiveRegion, null),
                        React.createElement(MotionTrack, null, props.items.map((item, index) => (React.createElement(S.Item, { key: item.id }, props.renderItem(item, index)))))))))));
}
export default CardCarousel;
